import { lazy } from "react";

const ClawbackModule = lazy(() =>
  import("../Component/Invoice/Clawback/ClawbackModule"),
);

// ============================================================
// CLAWBACK MANAGEMENT & RECOVERY
// ============================================================
const clawbackRoutes = [{ path: "/clawback", element: <ClawbackModule /> }];

export default clawbackRoutes;
